import storageService from '@/modules/common/services/storageService';

const state = {
  isInitComplete: false,
  isMobile: false,
  isMobileApp: window.navigator.userAgent.match('vcitapp') !== null,
  isiPhone: window.navigator.userAgent.match('iPhone') !== null,
  isAndroid: window.navigator.userAgent.toLowerCase().match('android') !== null,
  isRtl: false,
};

storageService.save('isMobileApp', state.isMobileApp);

const getters = {
  isInitComplete: (state) => state.isInitComplete,
  isMobile: (state) => state.isMobile,
  isMobileApp: (state) => state.isMobileApp,
  isiPhone: (state) => state.isiPhone,
  isAndroid: (state) => state.isAndroid,
  isRtl: (state) => state.isRtl,
};

const mutations = {
  setIsInitComplete(state, isInitComplete) {
    state.isInitComplete = isInitComplete;
  },
  setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
  setIsRtl(state, isRtl) {
    state.isRtl = isRtl;
  },
};

const actions = {
  setIsInitComplete({ commit }, isInitComplete) {
    commit('setIsInitComplete', isInitComplete);
  },
  setIsMobile({ commit }, isMobile) {
    commit('setIsMobile', isMobile);
  },
  setIsRtl({ commit }, isRtl) {
    commit('setIsRtl', isRtl);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
